import { WidenImageConfig } from '@models/widen-image-config';
import type { ImageLoaderProps } from 'next/image';
import type { WidenCropKeepArea } from './constants';
import { WidenUtil } from './widen-utils';

export interface widenImageLoaderProps extends ImageLoaderProps {
  animate?: boolean;
  color?: string; // color is a string with a max length of 8 characters in hexadecimal format, e.g. "ffffffff"
  crop?: boolean;
  height?: number;
  keep?: WidenCropKeepArea;
}

export function widenImageLoader(imageProps: widenImageLoaderProps): string {
  const { src, width, height, quality, animate, color, crop, keep } = imageProps;

  const imageID = WidenUtil.extractWidenImageId(src);
  const imageName = WidenUtil.extractWidenImageName(src);

  const config = new WidenImageConfig(
    imageID,
    imageName,
    WidenUtil.limitMeasurement(width),
    WidenUtil.limitMeasurement(height),
    quality,
    animate,
    crop,
    keep,
    color
  );

  return WidenUtil.getWidenCDNUrl(config);
}
